import Home from "./Home.js";
import UserSignIn from "./UserSignIn.js";
import Register from "./Register.js";
import ForgotPassword from "./ForgotPassword.js";
import ResetPassword from "./ResetPassword.js";
import UploadIndex from "./UploadIndex.js";
import FileUpload from "./FileUpload.js";
import PasteUpload from "./PasteUpload.js";
import Analysis from "./Analysis.js";
import MyDocuments from "./MyDocuments.js";
import Profile from "./Profile.js";
import Preferences from "./Preferences.js";
import OtpVerification from "./OtpVerification.js";
import LoadingPage from "./LoadingPage.js";
import AnalysisRouter from "./AnalysisRouter.js";

import { GoPerson, GoHomeFill, GoSignIn, GoLog, GoUpload } from "react-icons/go";

const PageRoutes = [
            {
                title: "Home",
                path: "/",
                element: <Home/>,
                icon: GoHomeFill,
                id: "home"
            },
            {
                title: "Signin",
                path: "/signin",
                element: <UserSignIn/>,
                icon: GoSignIn,
                id: "signin"
            },
            {
                title: "Register",
                path: "/register",
                element: <Register/>,
                icon: GoSignIn,
                id: "register"
            },
            {
                path: "/password/forgot",
                element: <ForgotPassword />,
            },
            {
                path: "/password/reset/:token",
                element: <ResetPassword />,
            },
            {
                title: "Upload",
                path: "/upload",
                element: <UploadIndex/>,
                icon: GoUpload,
                id: "uploadindex"
            },
            {
                title: "Analyze",
                path: "/analysis/:tcid",
                element: <Analysis/>,
                id: "analysis"
            },
            {
                title: "Analyze Document",
                path: `/analysis`,
                element: <AnalysisRouter/>,
                icon: GoLog,
                needsAuth: false,
                needTC: true,
                id: "analysisrouter"
            },
            {
                title: "My Documents",
                path: "/mydocuments",
                element: <MyDocuments/>,
                icon: GoLog,
                id: "history"
            },
            {
                title: "Profile",
                path: "/profile",
                element: <Profile/>,
                icon: GoPerson,
                id: "profile"
            },
            {
                title: "Preferences",
                path: "/preferences",
                element: <Preferences/>,
                icon: GoPerson,
                id: "preferences",
            },
            {
                path: "/fileupload",
                element: <FileUpload />,
            },
            {
                path: "/pasteupload",
                element: <PasteUpload />,
            },
            {
                path: "/otp-verification/:uid", 
                element: <OtpVerification />,
            },
            {
                path: "/loading",
                element: <LoadingPage />,
            },
];

export default PageRoutes;
